import type { TPropostaSchemaInput } from '@/features/proposta/brasil/domain/schemas'
import { StringUtils } from '@/utils'

export function transformarClienteParaEmailDocumento(
  clientesPessoaFisica: TPropostaSchemaInput['cadastroCompradores']['clientes'],
): Record<string, string> {
  const resultado: Record<string, string> = {}

  clientesPessoaFisica.forEach((cliente) => {
    if (cliente.maiorDe18Anos) {
      resultado[cliente.email] = StringUtils.normalize(cliente.cpf)
    }
  })

  return resultado
}
